import {
  Dialog as HeadlessDialog,
  DialogBackdrop as HeadlessDialogBackdrop,
  DialogPanel as HeadlessDialogPanel,
  type DialogProps as HeadlessDialogProps,
} from "@headlessui/react";
import type { VariantProps } from "class-variance-authority";
import { classNames } from "../../utils/classNames";
import { alertVariants } from "./variants";

export type AlertProps = {
  children: React.ReactNode;
} & HeadlessDialogProps &
  VariantProps<typeof alertVariants>;

export function Alert({
  open = false,
  onClose,
  size = "md",
  className,
  children,
  ...props
}: AlertProps) {
  return (
    <HeadlessDialog onClose={onClose} open={open} {...props}>
      <HeadlessDialogBackdrop
        transition
        className="fixed inset-0 z-20 bg-zinc-950/15 dark:bg-zinc-950/50 duration-100 ease-out data-[closed]:opacity-0"
      />

      <div className="fixed inset-0 z-20 grid grid-rows-[1fr_auto_1fr] justify-items-center p-8 sm:grid-rows-[1fr_auto_3fr] sm:p-4">
        <HeadlessDialogPanel
          className={classNames(alertVariants({ size }), className)}
          transition
        >
          {children}
        </HeadlessDialogPanel>
      </div>
    </HeadlessDialog>
  );
}
